import { NewAccountEntityType, NewAccountType } from 'common';
import { ContactDto } from './contact.dto';
import { IGeneralDetailsData } from '../../../interfaces/account-registration/general-details-data.interface';
import { ILicenceTypeData } from '../../../interfaces/account-registration/licence-type-data.interface';
import { AddressDto } from './address.dto';

export class GeneralDetailsDto {
  code: string;
  type: string;
  name: string;
  officialName: string;
  tradeName: string;
  feeExempt: boolean;
  isClubAccount: boolean;
  documentationPreferences: DocumentationPreferencesDto;
  contact: ContactDto;

  constructor(accountType: NewAccountType, generalDetailsData: IGeneralDetailsData, licenceTypesData: ILicenceTypeData = null) {
    this.code = '';
    this.type = accountType;
    this.name = generalDetailsData.accountName.value;
    this.officialName = generalDetailsData.officialName.value;
    this.tradeName = generalDetailsData.tradeName.value;
    this.feeExempt = false;
    this.isClubAccount = licenceTypesData?.isClubAccount.value ?? false;

    //Documentation Preferences
    this.documentationPreferences = new DocumentationPreferencesDto(
      Number(generalDetailsData.docPrefDeliveryMethod.value),
      Number(generalDetailsData.docPrefLanguage.value)
    );

    //general details contact
    this.contact = new ContactDto();
    this.contact.isCompany = generalDetailsData.entityType.value === NewAccountEntityType.Company;
    this.contact.contactId = -1;
    this.contact.attributes = [];
    this.contact.salutation = generalDetailsData.salutation.value;
    this.contact.firstname = generalDetailsData.firstName.value;
    this.contact.lastname = generalDetailsData.lastName.value;
    this.contact.positionHeld = '';
    this.contact.phone = generalDetailsData.phone.value;
    this.contact.phoneAlternative = '';
    this.contact.fax = '';
    this.contact.mobilePhone = generalDetailsData.mobile.value;
    this.contact.email = generalDetailsData.email.value;
    this.contact.website = '';
    this.contact.dateOfBirth = '';
    this.contact.placeOfBirth = '';
    this.contact.disabilityPension = false;
    this.contact.address = new AddressDto(
      generalDetailsData.addressLine1.value,
      generalDetailsData.addressLine2.value,
      generalDetailsData.addressLine3.value,
      generalDetailsData.addressLine4.value,
      generalDetailsData.postCode.value,
      generalDetailsData.county.value,
      generalDetailsData.country.value
    );
    this.contact.licences = [];
  }
}

class DocumentationPreferencesDto {
  deliveryMethod: number;
  language: number;

  constructor(deliveryMethod: number, language: number) {
    this.deliveryMethod = deliveryMethod;
    this.language = language;
  }
}
